module.exports = __webpack_public_path__ + "media/country_flags/ec-5a5a1950.png";